
<div class="tonnage-results">
  <div class="tonnage-title" *ngIf="isResultsAvailable()">
    <h2>Train Profiles</h2>
  </div>
  <lms-lms-tonnage-lmps-table *ngIf="showLMPS"
                              [lmpsTonnageRatings]="tonnageRatingHandlerData"
                              [lmpsHeadings]="lmpsHeadings">
  </lms-lms-tonnage-lmps-table>
</div>
